import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import appStoreBadge from './assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import googlePlayBadge from './assets/images/GetItOnGooglePlay_Badge_Web_color_English.png';

function Footer() {
  return (
    <footer className="Footer">
      <div className="Footer-Content">
        <p>&copy; {new Date().getFullYear()} <a href="https://chaylevell.com/" className="Footer-Link" target="_blank" rel="noopener noreferrer">Chay Levell</a>. All rights reserved.</p>
        <h5>
          <Link className='Footer-Link' to="/privacy">Privacy Policy</Link>
        </h5>
        <h1 className="Title">Island City News</h1>
        <div className="App-Store-Badges">
          <Link to="/download" className="App-Store-Badge-Link">
            <img 
              src={appStoreBadge} 
              alt="Download on the App Store" 
              className="App-Store-Badge"
            />
          </Link>
          <Link to="/download" className="App-Store-Badge-Link">
            <img 
              src={googlePlayBadge} 
              alt="Get it on Google Play" 
              className="Google-Play-Badge"
            />
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
